import React from 'react';

/* Utilities */
import { getImageFraction, trans } from 'js/utilities';

export default function ConversionFlowVehicleImage({ vehicle }) {
    return (
        <>
            <div className="d-flex align-items-center justify-content-between">
                <div className="h5 font-weight-extra-bold">{trans('flow.summary.title')}</div>
                <img
                    {...(vehicle?.image ?

                            getImageFraction({
                                path: vehicle.image,
                                ratio: 3 / 2,
                                fraction: 1 / 12,
                            })
                            :
                            {}
                    )}
                    alt={vehicle.name}
                    height="auto"
                    className="summary-vehicle-image img-fluid rounded"
                />
            </div>
        </>
    )
}
